import type { Route } from '~/core/router'

import * as expired from '~/routes/auth/expired'
import * as fail from '~/routes/auth/fail'
import * as forgotPasswordRoot from '~/routes/auth/forgot-password/_'
import * as forgotPasswordDone from '~/routes/auth/forgot-password/done'
import * as forgotPasswordFail from '~/routes/auth/forgot-password/fail'
import * as forgotPasswordNew from '~/routes/auth/forgot-password/new'
import * as forgotPasswordVerify from '~/routes/auth/forgot-password/verify'
import * as geoblock from '~/routes/auth/geoblock'
import * as logout from '~/routes/auth/logout'
import * as signin from '~/routes/auth/sign-in'
import * as signUpRoot from '~/routes/auth/sign-up/_'
import * as signUpDone from '~/routes/auth/sign-up/done'
import * as signUpFail from '~/routes/auth/sign-up/fail'
import * as subscriptionStatus from '~/routes/auth/subscription-status'
import * as toa from '~/routes/auth/toa'
import * as verify from '~/routes/auth/verify'
import { keys } from '~/shared/jail'
import { Footer } from '~/shared/ui/components/Footer'
import { NavBar } from '~/widgets/NavBar'
import { MessagePortal } from '~/widgets/Popups'

export const route: Route = {
  keys: [keys.sign, keys.guest],

  children: [
    {
      path: ['/sign-in/verify', '/sign-up/verify'],
      init: verify.authVerifyModel.init,
      component: [verify.Title, verify.VerifyPage, MessagePortal],
    },
    {
      path: '/sign-in{/*path}',
      init: signin.model.init,
      left: signin.model.left,
      component: [signin.Title, signin.SignInPage, MessagePortal],
    },
    {
      keys: [keys.toa],
      path: '/toa{/*path}',
      init: toa.model.init,
      component: [toa.Title, toa.ToaPage, MessagePortal],
    },
    {
      keys: [keys.expired],
      path: '/expired{/*path}',
      component: [expired.Title, expired.ExpiredPage, Footer, MessagePortal],
      init: expired.model.init,
    },
    {
      keys: [keys.master],
      path: '/logout{/*path}',
      component: [
        logout.Title,
        NavBar,
        logout.LogoutPage,
        Footer,
        MessagePortal,
      ],
      init: logout.model.init,
      left: logout.model.left,
    },
    {
      path: '/sign-up',
      children: [
        {
          path: '',
          init: signUpRoot.model.init,
          left: signUpRoot.model.left,
          component: [signUpRoot.Title, signUpRoot.SignUpPage, MessagePortal],
        },
        {
          path: '/done',
          component: [signUpDone.Title, signUpDone.DonePage],
        },
        {
          path: '/fail',
          component: [signUpFail.Title, signUpFail.FailPage],
        },
      ],
    },
    {
      path: '/forgot-password',
      children: [
        {
          path: '',
          init: forgotPasswordRoot.model.init,
          component: [
            forgotPasswordRoot.Title,
            forgotPasswordRoot.ForgotPasswordPage,
            MessagePortal,
          ],
        },
        {
          path: '/verify',
          init: forgotPasswordVerify.model.init,
          component: [
            forgotPasswordVerify.Title,
            forgotPasswordVerify.VerifyPage,
            MessagePortal,
          ],
        },
        {
          path: '/new',
          init: forgotPasswordNew.model.init,
          component: [
            forgotPasswordNew.Title,
            forgotPasswordNew.NewPasswordPage,
            MessagePortal,
          ],
        },
        {
          path: '/done',
          component: [forgotPasswordDone.Title, forgotPasswordDone.DonePage],
        },
        {
          path: '/fail',
          component: [forgotPasswordFail.Title, forgotPasswordFail.FailPage],
        },
      ],
    },
    {
      path: '/fail',
      component: [fail.Title, fail.ErrorPage],
    },
    {
      path: '/subscription-status',
      init: subscriptionStatus.model.init,
      component: [
        subscriptionStatus.Title,
        subscriptionStatus.SubscriptionStatusPage,
        Footer,
        MessagePortal,
      ],
    },
    {
      keys: [keys.geoblock],
      path: '/geoblock',
      component: [geoblock.Title, geoblock.GeoBlockPage],
    },
  ],
}
